import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group col-sm-12" }
const _hoisted_8 = { class: "overflow-auto" }
const _hoisted_9 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_10 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { class: "text-capitalize-first" }
const _hoisted_14 = { class: "text-capitalize-first" }
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "d-flex flex-row align-items-center gap-2 mt-1 mb-1" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = { class: "d-flex flex-column" }
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = {
  key: 0,
  class: "text-success text-capitalize-first"
}
const _hoisted_22 = {
  key: 1,
  class: "text-danger text-capitalize-first"
}
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_28 = ["onUpdate:modelValue", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayoutMethodForm = _resolveComponent("PayoutMethodForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.isTrader)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEditModal())),
                          class: "btn btn-outline-dark btn-sm rounded-pill float-end text-capitalize"
                        }, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.create')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isTrader)
                      ? (_openBlock(), _createBlock(_component_b_modal, {
                          key: 1,
                          "dialog-class": "modal-lg",
                          title: _ctx.createModalTitle,
                          modelValue: _ctx.createModal,
                          "body-class": "pt-0",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.createModal = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_PayoutMethodForm, { ref: "createForm" }, null, 512)
                          ]),
                          footer: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createModal = false)),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                            _createVNode(_component_LoaderWrapper, {
                              ref: "loaderCreateFrom",
                              zoom: 0.5
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save())),
                                  class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        }, 8, ["title", "modelValue"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("table", _hoisted_9, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_ctx.isAdmin || _ctx.isOperator)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.trader')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.payment_method')), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.helper.trans('labels.count_limits')), 1),
                        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.sum_limits')), 1),
                        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                        _cache[10] || (_cache[10] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payoutMethods.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id,
                          class: ""
                        }, [
                          (_ctx.isAdmin || _ctx.isOperator)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                (item.trader)
                                  ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                      key: 0,
                                      user: item.trader
                                    }, null, 8, ["user"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_PayMethodIcon, {
                                method: item.method
                              }, null, 8, ["method"]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + item.method)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.currency), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", null, _toDisplayString(item.dayTradesCount) + "/" + _toDisplayString(item.dayTradesCountLimit), 1),
                              _createElementVNode("span", null, _toDisplayString(item.monthTradesCount) + "/" + _toDisplayString(item.monthTradesCountLimit), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.dayTradesSumLimit)), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(item.monthTradesSumLimit)), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (item.isActive)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.helper.trans('requisites.active')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.helper.trans('requisites.inactive')), 1))
                          ]),
                          _createElementVNode("td", _hoisted_23, [
                            (_ctx.isTrader)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showEditModal(item)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap me-2 text-capitalize"
                                }, [
                                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                                ], 8, _hoisted_24))
                              : _createCommentVNode("", true),
                            (_ctx.isTrader)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.deletePayoutMethod = item),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                }, [
                                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-trash" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.delete')), 1)
                                ], 8, _hoisted_25))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin || _ctx.isOperator)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => (({isActive: item.isActive}.isActive) = $event),
                                      onChange: ($event: any) => (_ctx.toggleActivity($event, item)),
                                      id: "isActive",
                                      class: "form-check-input",
                                      style: {"cursor":"pointer"},
                                      type: "checkbox",
                                      role: "switch"
                                    }, null, 40, _hoisted_28), [
                                      [_vModelCheckbox, {isActive: item.isActive}.isActive]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.payoutMethods.totalCount > _ctx.payoutMethods.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[5] || (_cache[5] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.payoutMethods.totalCount,
                        "per-page": _ctx.payoutMethods.limit,
                        limit: 20,
                        "prev-text": _ctx.helper.trans('button.back'),
                        "next-text": _ctx.helper.trans('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_b_modal, {
          title: _ctx.helper.trans('labels.delete_confirm'),
          modelValue: _ctx.deletePayoutMethod !== null,
          "body-class": "d-none",
          "footer-class": "border-top-0 d-flex justify-content-between",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($event === false && (_ctx.deletePayoutMethod = null)))
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deletePayoutMethod = null)),
              class: "btn btn-outline-dark btn-sm text-capitalize"
            }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
            _createVNode(_component_LoaderWrapper, {
              ref: "loaderDelete",
              zoom: 0.5
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmDelete())),
                  class: "btn btn-outline-danger btn-sm text-capitalize"
                }, _toDisplayString(_ctx.helper.trans('button.delete')), 1)
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["title", "modelValue"])
      ])
    ]),
    _: 1
  }, 512))
}